import { inject, Injectable } from '@angular/core';
import { collection, doc, docData, DocumentData } from '@angular/fire/firestore';
import { map, Observable } from 'rxjs';
import { PublicPaymentInfoDao } from '../models/public-payment-info';
import { TenantRepository } from './tenant.repository';

const PAYMENT_COLLECTION = 'payment';

@Injectable({
    providedIn: 'root',
})
export class PaymentRepository {
    private readonly tenantRepository = inject(TenantRepository);

    private readonly paymentRef = collection(this.tenantRepository.tenantRef, PAYMENT_COLLECTION);

    public getPublicPaymentInformationForTenant(): Observable<PublicPaymentInfoDao | undefined> {
        return docData(doc(this.paymentRef, 'public')).pipe(
            map((paymentInfo) => (paymentInfo ? this.fromFirestore(paymentInfo) : undefined)),
        );
    }

    private fromFirestore(document: DocumentData): PublicPaymentInfoDao {
        return {
            owner: document.owner,
            license: document.license,
            endOfFreeTrial: document.endOfFreeTrial,
            trialInvitationsCount: document.trialInvitationsCount,
        };
    }
}
